import { Component, input } from '@angular/core';

@Component({
  selector: 'dialog-header',
  imports: [],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  // inputs
  slot = input<"spaced" | "end">()
}
